export default {
    // 双十二接口
    // 签到列表
    listSignRecord: '/api/doubleTwelveActivity/listSignRecord',
    // 签到接口
    doSign: '/api/doubleTwelveActivity/doSign',
    // 商品列表
    listProductIds: '/api/office/doubleTwelve/listProductIds',
    // 获取服务器时间
    getServerTime: '/api/office/doubleTwelve/timestamp',
    // 获取商品列表（通用）
    get_goods_list: '/api/newYear/noClosing/productList',
    get_goods_listV2: '/api/newYear/noClosing/productListV2',
    // 新人活动备考必买单品推荐  返回商品信息+优惠券
    get_goods_listV3: '/api/newYear/noClosing/getProductList',

    // 获取手机验证码
    get_phone_code: '/api/office/userLogin/sendSmsLoginCode',
    // 登录
    login: '/api/office/userLogin/userLogin',
    // 登出
    logout: '/api/office/userLogin/logout',
    // 获取用户信息
    get_user_info: '/api/office/user/getSimpleUserByToken',
    get_user_infoV2: '/api/office/user/getSimpleUserByTokenV2',
    // 师资列表
    teacher_list: '/api/app/teacher/listHomePage',
    // 公开课
    open_class: '/api/app/school/emall/product/type/getOpenClassByBusinessId',
    // 热销榜
    hot_list: '/api/office/school/emall/product/hotList',
    // 分享笔记相关接口
    share_note: '/api/mynote/share/note/detail',
    // 首页banner
    banner_config_school: '/api/h5/school/emall/listBannerConfigSchool',
    // pc首页banner
    listBannerConfigSchool: '/api/office/school/emall/listBannerConfigSchool',
    listBannerConfigSchoolV2: '/api/office/school/emall/listBannerConfigSchoolV2',
    // pc首页热销榜
    pageAppBarForPCIndex: '/api/office/emall/product/pageAppBarForPCIndex',
    // pc首页师资
    listZhTeachers: '/api/office/school/emall/listZhTeachersV2',
    // 首页师资列表
    home_teachers: '/api/h5/school/emall/listZhTeachers',
    // 订单类型列表
    order_type_list: '/api/office/app/h5/order/getPayStatus',
    // 我的订单列表
    // order_my_list: '/api/office/app/h5/order/myOrderList',
    //我得订单列表 新增积分商品
    // order_my_list: '/api/office/app/order/myOrderList2',
    // 我的订单列表 新增购物车商品
    order_my_list: '/api/orderSearch/myOrderList',
    // 获取商品的课程目录
    get_lessons: '/api/office/emall/product/getLessons',
    // 根据目录id获取视频列表
    get_lessons_by_cat_id: '/api/office/emall/product/getLessonsByCatId',
    // 商城课程附件
    get_ware_list: '/api/office/emall/product/getWareList',
    // 获取某个课程下的配套资料
    get_lesson_ware_list: '/api/office/emall/product/getLessonWareList',
    // 获取腾讯视频签名接口
    tencent_sign: '/api/tencent/sign',

    // 每日一题----
    // 每日一题 - 今日题目
    oneDay_getOneQuestionData: '/api/office/everydayOneQuestion/todayQuestion',
    // 每日一题 - 往日题目
    oneDay_myGetPastQuestions:
        '/api/office/everydayOneQuestion/getPastQuestions',
    getPastQuestionsFromProductDetail:'/api/office/everydayOneQuestion/getPastQuestionsFromProductDetail',
    // 每日一题 - 详情
    oneDay_getTodayQuestion: '/api/office/everydayOneQuestion/getTodayQuestion',
    // 每日一题判断用户是否封禁
    oneDay_isResult: '/api/user/banned/check/result',
    // 根据商品规格id和练习id获取随堂练习
    get_classroom_by_lessonId_skuId:
        '/api/simulation/classroom/getCoursePractice',
    // 根据随堂练习主键id获取随堂练习信息
    get_classroom_by_classroomPracticeId:
        '/api/simulation/classroom/course/practiceStatus',

    // 我的
    // 我的笔记
    my_note: '/api/mynote/my/note/list/productspec',
    // 日历
    my_table: '/api/course/table/list/course/table',
    // 请求课程表视频列表
    my_card:'/api/course/table/list/course/table/card',
    // 每日一题 - 回答
    oneDay_answer: '/api/office/everydayOneQuestion/answer',
    // 每日一题 - 举报
    oneDay_report: '/api/office/everydayOneQuestion/inform',
    // 每日一题 - 获取举报类型
    oneDay_get_report_class: '/api/professionalQa/qaDictList',
    // 每日一题 - 我的作答
    oneDay_get_myAnswer: '/api/office/everydayOneQuestion/myAnswer',
    // 每日一题 - 其他作答
    oneDay_get_otherAnswer: '/api/office/everydayOneQuestion/otherAnswer',
    // 每日一题列表 - 商品信息
    oneDay_get_selectTitle:
        '/api/office/emall/product/selectTitleThumbSkuNameByProductIdAndSkuId',

    // 弹窗图片上传接口
    uploadUrl: '/api/office/app/h5/order/uploadRefundProve',
    // 课程问答列表
    course_list_api:
        '/api/office/professionalQa/qaTeacherAnswerListByProductId',
    // 课程问答获取科目
    course_getSubject_api: '/api/office/dispatch/listSubjectType',
    // 课程问答题问
    course_list_qa_api: '/api/office/professionalQa/qaAsk',
    // 会员信息
    member_information: '/api/user/member/userMemberCenter',
    // 移动端——新增专业答疑——获取某商品提问回答列表
    qaAskAnAnswerListByProductId:
        '/api/office/professionalQa/qaAskAnAnswerListByProductId',
    // 官网——新增专业答疑——追问
    qa_replenish_ask: '/api/office/professionalQa/qaReplenishAsk',
    // 官网——新增专业答疑——我来回答
    qa_answer: '/api/office/professionalQa/qaAnswer',
    // 官网——举报
    qa_report: '/api/office/professionalQa/qaReport',
    // 接收客户端发送的心跳协议->(app+pc+h5)
    beat_jump: '/api/heart/beat/jump',
    // 我的提问我的回答
    my_answer_my_question: '/api/office/professionalQa/qaUserList',
    // pc端——播放器用户学习时长排行榜
    cw_rank: '/api/course/duration/rank',
    // 获取直播地址
    tencent_entry: '/api/office/live/tencent/entry',
    // 获取视频笔记
    note_one: '/api/mynote/one',
    // 添加笔记接口
    note_add: '/api/mynote/add',
    // 修改笔记接口
    note_update: '/api/mynote/update',
    // 是否被禁言
    note_banned: '/api/user/banned/check/result',
    // 分页获取我的笔记列表
    note_list: '/api/mynote/my/note/list/page',
    // 分页获取大家笔记列表
    note_list_all: '/api/mynote/everyone/note/list/page',
    // 删除笔记
    note_delete: '/api/mynote/delete/byId',
    // 获取举报原因列表
    report_reason: '/api/mynote/report/reasons',
    // 新增笔记的举报信息
    report_add: '/api/mynote/report/reason/add',

    // 竹马相关接口

    // 竹马获取导航栏
    get_topbar_list: '/api/office/actionbar/online/list',
    // 获取验证码
    zhuma_get_phone_code: '/api/zmweb/v1/user/smsLoginCode',
    // 竹马登录 老接口
    zhuma_login: '/api/zmweb/v1/user/login',
    // 竹马首页商城业务类型列表
    zhuma_homeBusinessList: '/api/office/student/businessType/selectBusiness',
    zhuma_homeBusinessListV2: '/api/office/student/businessType/selectBusinessV2',
    // 竹马首页获取商品列表
    zhuma_homePageAppBarForPCIndex:
        '/api/office/emall/product/pageAppBarForPCIndex',
        // 竹马首页获取商品列表
    zhuma_homePageAppBarForPCIndex_new1:
    '/api/office/emall/product/pageHomeForPCIndex',
  zhuma_homePageAppBarForPCIndex_new1V2:
    '/api/product/listV3/getPageForPcZhumaHome',
    // 竹马首页 二级分类 （主观客观）
    zhuma_homeQuestionType: '/api/p3/question/list/questionType',
    zhuma_homeQuestionTypeV2: '/api/p3/question/list/questionTypeV2',
    // 竹马首页题集列表
    zhuma_homeGetNavbarExpress: '/api/office/p3/module/show/getNavbarExpress',
   zhuma_homeGetNavbarExpressV2: '/api/office/p3/module/show/getNavbarExpressV2',
    zhuma_homeNode: '/',
    // 竹马首页轮播图
    zhuma_getOnlineBannerListForPc: '/api/module/show/getOnlineBannerListForPc',
    zhuma_getOnlineBannerListForPcV2: '/api/module/show/getOnlineBannerListForPcV2',
    // 获取登录二维码 老接口
    get_login_qrcode: '/api/zmweb/v1/user/qrLoginImage',
    // 检查二维码是否登录
    check_qrcode_login: '/api/userLogin/userLogin',
    // 热销榜列表
    page_app_bar_for_pc_index: '/api/office/emall/product/pageAppBarForPCIndex',
    // 获取商品详情
    get_product_info: '/api/office/school/emall/selectById',
    // 更新商品列表数据接口（竹马）
    zhuma_local_refresh: '/api/office/school/emall/product/localRefresh',
    // 获取优惠券列表
    get_coupon_list:
        '/api/office/school/emall/coupon/listCouponByConditionForProductInfo',
    // 领取优惠
    claim_coupon: '/api/office/userCoupon/claimCoupon',
    // 获取推荐商品、推荐标签
    select_ad_by_id: '/api/office/school/emall/selectAdById',
    zhuma_emall_select_ad_byid: '/api/office/zhuma/emall/selectAdByIdV2',
    zhonghe_emall_select_ad_byid: '/api/office/school/emall/selectAdByIdV2',
    // 今日任务
    task_detail: '/api/office/today/task/taskDetail',
    // 课程目录
    lessons: '/api/office/emall/product/lessons',
    // 配套资料
    wareList: '/api/office/emall/product/wareList',
    // 查询是否有待支付订单
    get_prepaid_orders_by_product_id:
        '/api/app/order/getPrepaidOrdersByProductIdAndSkuId',
    // 课程信息
    get_lessons_info: '/api/office/emall/product/getLessonsInfoV2', // /api/office/emall/product/getLessonsInfoV2
    // 加入学习
    join_study: '/api/course-expiration/join/study',
    // 商品详情tab权限（每日一题、专业答疑）
    property_list: '/api/office/product/property/propertyList',
    // 每日一题数据
    today_question: '/api/office/everydayOneQuestion/todayQuestion',
    // 预约活动
    appointment_save: '/api/office/mall/user/product/appointment/save',

    // 答题解析
    // 答题解析视频获取验签
    exercise_video: '/api/tencent/sign',
    getAnalysis: '/api/activity/mockExam/getAnalysis',
    // 通过id获取富文本数据
    get_system_data: '/api/generalConfigure/selectByTitle',
    // 通过code获取富文本数据
    get_system_data_bycode: 'api/generalConfigure/oneByCode',

    // 众合相关接口

    // 更新商品列表数据接口（众合）
    zhonghe_local_refresh: '/api/office/school/emall/product/localRefresh',
    // 众合首页公开课
    zhonghe_listProductOpenClass:
        '/api/office/school/emall/listProductOpenClass',
    // 众合首页商品接口
    zhonghe_listHomePage: '/api/office/school/emall/listHomePage',
    zhonghe_listHomePage: '/api/office/school/emall/listHomePage',
    zhonghe_listHomePage_new: '/api/product/listV3/getListForPcSchoolHome',
    // 双11活动相关接口
    get_server_time: '/api/office/doubleElevenActivity/getCurrentTimestamp',
    get_server_timeV2: '/api/office/doubleElevenActivity/getCurrentTimestampV2',

    // 法考活动接口
    listByIds: '/api/activity/product/listByIds',

    // 模考法条
    mokao_fatiao: '/api/laws/list',
    mokao_fatiaoV2: '/api/laws/listV2',
    // 查询法条详情
    fatiao_detail: '/api/laws/info',
    fatiao_detailv2: '/api/laws/infoV2',
    // 模考抽奖-是否抽过奖
    mokao_virifyDraw: '/api/office/lottery/virifyDraw',
    // 模考抽奖-填写收货地址
    mokao_add_address: '/api/office/lottery/addAddress',
    // 模考抽奖-获取省
    mokao_get_classa_parent: '/api/office/school/emall/getClassaParent',
    // 模考抽奖-获取市/区
    mokao_getAnalysisRegionVo: '/api/office/school/emall/getAnalysisRegionVo',
    // 模考抽奖-抽奖
    mokao_draw: '/api/office/lottery/drawLottery',
    // 模考反馈-是否反馈过
    mokao_virifyComment: '/api/office/comment/verifyComment',
    // 模考反馈-反馈
    mokao_add_coment: '/api/office/comment/addComment',
    // 模考-获取当前时间
    mokao_current_time: '/api/activity/mockExam/currentTime',
    // 模考-用户报名
    mokao_apply: '/api/activity/mockExam/apply',
    // 模考-活动状态
    mokao_activity_status: '/api/activity/mockExam/status',
    // 获取题目和答题信息
    get_test_paper: '/api/activity/mockExam/getTestPaper',
    // 模考-获取答题分数及排名
    mokao_get_grade_and_ranking: '/api/activity/mockExam/getGradeAndRanking',
    // 答题
    mock_exam_answer: '/api/activity/mockExam/answer',
    // 用户学习历史列表
    study_history: '/api/course/list/history',
    // 用户学习历史列表 第二版
    study_history_v2: '/api/course/history/page',
    // 新增用户资料下载记录
    download_file_add: '/api/user-download-file/add',

    // 获取公开课id
    get_open_class_id_zhuma: '/api/office/zhuma/emall/getOpenClass',
    get_open_class_id_zhonghe: '/api/office/school/emall/getOpenClass',
    // 公开课属性
    open_class_type_attr_zhuma: '/api/office/zhuma/emall/listByTypeId',
    open_class_type_attr_zhonghe: '/api/office/school/emall/listByTypeId',
    // 公开课列表
    get_open_class_list_zhuma: '/api/office/zhuma/emall/getOpenClassList',
    get_open_class_list_zhonghe: '/api/office/school/emall/getOpenClassList',
    // 我的-订单登记列表
    my_userlist: '/api/office/internal/third/userlist/',
    // 订单登记列表
    userlist: '/api/internal/third/userlist',
    // 订单登记 - 判断三方订单是否存在，存在需要返回三方订单地址信息
    hasOrderInfo: '/api/third/hasOrderInfo',
    // 设置默认地址
    setDefaultAddress: '/api/userAddress/setDefaultAddress',

    // 订单登记 - 登记
    userBindOrder: '/api/third/userBindOrder',
    // 我的-订单登记登记
    my_userbind: '/api/office/internal/third/userbind',
    // 我的-订单登记
    // 获取默认地址或者最近编辑的地址
    getDefaultAddress: '/api/userAddress/getDefaultAddress',
    // 我的课程-是否有直播课
    get_my_lessons_is_live: '/api/course/table/has/live/lesson',
    // 我的课程-列表
    get_my_lessons_list: '/api/course/page/mycourse',
    // 我的课程-退出课程
    del_my_lessons_exit: '/api/course-expiration/exit/course',
    // 我的课程-选取课程是否有课程
    get_my_lessons_is_lesson: '/api/office/emall/product/getLessonsInfoV2', // /api/office/emall/product/getLessonsInfoV2
    // 获取课程类型
    get_lessons_type: '/api/office/app/emall/type/typeList',
    // 获取支付地址列表
    list_address: '/api/userAddress/listAddress',
    // 获取商品信息和规格
    select_by_id_and_skuid:
        '/api/office/school/emall/product/selectByIdAndSkuId',
    // 获取优惠券
    choice_coupon_list: '/api/userCoupon/choiceCouponList',
    // 查询待支付订单详情
    my_order_details_trade_no:
        '/api/office/app/h5/order/myOrderDetailsByTradeNo',
    // （新 积分商城）查询待支付订单详情 -
    jifen_my_order_details_trade_no:
    '/api/office/app/order/myOrderDetailsByTradeNo2',
    jifen_getPointProductList:'/api/pointProduct/getPointProductList',
    // 积分列表 分类tab
    jifen_getGroupList:'/api/pointProduct/getGroupList',
    // 积分商品详情
    jifen_getProductAndRecommend:'/api/pointProduct/getProductAndRecommend',
    // 积分商城 兑换记录
    jifen_pointExchangeRecord:'/api/point/pointExchangeRecord',
    // 积分明细
    jifen_getPointInfoByUserId:'/api/pointsRecord/getPointInfoByUserId',
    // 获取分享链接
    activity_share: '/api/office/school/emall/product/activityShare',
    // 计算运费
    get_total_amount_and_freight:
        '/api/office/school/emall/coupon/getTotalAmountAndFreight',
    // 继续支付
    continue_payment_pc: '/api/office/app/h5/order/continuePaymentPc',
    // 创建订单
    create_online_order_pc: '/api/office/app/h5/order/createOnlineOrderPc',
    // 众合法考/法硕资讯分类接口
    get_pc_category_list: '/api/pcNews/getPcCategoryList',
    // 众合法考/法硕，根据分类获取对应的资讯列表
    get_pc_news_list: '/api/pcNews/list',
    // 众合法考/法硕，根据标签 id 获取对应的资讯列表
    get_tags_news_list: '/api/pcNews/getTagsNewsList',
    // 资讯详情
    getNewsDetail: '/api/pcNews/getNewsDetail',
    // 热门资讯
    getHotNews: '/api/pcNews/getHotNews',
    // 最新资讯
    getNewestNews: '/api/pcNews/getNewestNews',
    // 热门标签列表
    getHotTags: '/api/pcNews/getHotTags',
    // 获取课程有效期（不判断是否有课程，只判断crm后台商品详情配置的课程有效期）
    get_product_limit: '/api/office/school/emall/product/getProductLimit',
    // 新建、编辑地址
    edit_user_address: '/api/userAddress/editUserAddress',
    // 凑团接口
    join_group_purchasePc: '/api/office/app/h5/order/joinGroupPurchasePc',
    // 发起拼团接口
    start_group_purchasePc: '/api/office/app/h5/order/startGroupPurchasePc',
    /* 师资 */
    // 获取师资类型
    get_teacher_type: '/api/office/school/emall/listZhTeachersLabel',
    // 师资banner
    get_teacjer_banner: '/api/office/school/module/show/online/teacherBanner',
    // 获取师资详情
    get_teacher_detail: '/api/office/school/emall/teacher/getInfoById',
    /* 题库首页相关 */
    // 获取已选业务类型
    get_bu_checked: '/api/office/student/businessType/selectBusiness',
    get_bu_checkedV2: '/api/office/student/businessType/selectBusinessV2',
    // 获取全部业务类型
    get_bu_list: '/api/office/question/businesstype/list',
    // 保存业务类型
    save_bu: '/api/office/student/businessType/insert',
    // 获取数据报告
    get_data_report: '/api/question/answer/indexImpAnswerStatistics',
    // 获取模块配置
    get_navbar_express: '/api/office/p3/module/show/getNavbarExpress',
    get_navbar_expressV2: '/api/office/p3/module/show/getNavbarExpressV2',
    // 搜题提示
    get_search_question_tips: '/api/question/copywriting/select',
    // 获取题
    get_question_type: '/api/p3/question/list/questionType',
   get_question_typeV2: '/api/p3/question/list/questionTypeV2',
    // 获取题目录
    get_catalog: '/api/office/question/list/selectCatalogByParentId',
    get_catalogV2: '/api/office/question/list/selectCatalogByParentIdV2',
    // 获取练习历史
    get_history_list: '/api/office/question/answer/selectAnswerByKindId',
    // 我的题库
    get_my_question: '/api/p3/question/answer/mineQuestionBank',
    // 获取题（老法考）
    get_catalog_old: '/w/shuati',
    // 获取练习历史（老法考）
    get_history_list_old: '/api/zmweb/v1/my/history',
    // 获取用户做题历史
    get_question_history: '/api/p3/question/answer/selectAnswerByKindId',
    selectHistoryAnswerByQuestionTypeId:'/api/office/p3/question/answer/selectHistoryAnswerByQuestionTypeId',
    // 获取catelogId
    get_catelogId: '/api/office/question/bank/pcSelectByCatalogId',
    /* 题库首页相关 */

    // 获取电子法条列表
    get_electrinic_law_list: '/api/laws/list',

    // 增补勘误查询
    view_bookerrata: '/api/bookErrata/pageErrata',
    // 增补勘误科目
    view_bookerrata_subject: '/api/bookErrata/querySubject',
    // 优惠券列表
    my_coupon_list: '/api/userCoupon/myCouponList',
    // 优惠券可用商品
    list_product_by_couponId: '/api/office/emall/coupon/listProductByCouponId',
    // 获取优惠券信息
    select_by_id_for_pc: '/api/office/emall/coupon/selectByIdForPC',
    // 查询当前优惠券可用业务类型
    list_business_type_by_coupon_id:
        '/api/office/emall/coupon/listBusinessTypeByCouponId',
    // 删除订单
    // my_order_delete: '/api/office/app/h5/order/myOrderDelete',
    my_order_delete: '/api/order/v2/myOrderDelete',
    // 取消订单
    my_order_cancel_payment: '/api/office/app/h5/order/myOrderCancelPayment',

    // 搜索结果页
    get_search_result: '/api/product/listV3/getPageByKeyword',
    // 众合获取业务类型
    get_buType_zhonghe: '/api/office/school/businessType/select',
    // 商品列表
    goods_list: '/api/office/school/emall/pageListByConditions',
    // 获取课程类型名称 根据 类型id
    goods_type: '/api/office/zhuma/emall/product/typeInfo',
    // 学习计划问题列表
    my_study_plan_question: '/api/studyDiagnostics/questionList',
    // 学习计划保存
    my_study_plan_save: '/api/studyDiagnostics/saveDiagnostics',

    /**
     * 2022春节不打烊活动
     */
    noclosing_get_teachers: '/api/newYear/noClosing/benedictionList',
    get_barrages: '/api/newYear/noClosing/bulletChatList',
    noclosing_update_video: '/api/newYear/noClosing/updateLookStatus',

    // 招聘列表数据
    get_recruit_data: '/api/internal/recruitmentPost/list',
    // 岗位类别数据
    campus_recruitment_getlist: '/api/internal/recruitmentPostType/list',
    // 宣讲会列表
    metting_require_list: '/api/internal/recruitmentTeachIn/list',
    // 商品列表业务类型
    product_list_business: '/api/office/school/emall/list',
    // 竹马商品列表类型
    zhuma_app_bar_list: '/api/office/zhuma/emall/appBar/appBarlist',
    // 众合商品列表类型
    zhonghe_app_bar_list: '/api/office/school/emall/appBar/appBarlist',
    // 竹马商品属性
    zhuma_property_list: '/api/office/zhuma/emall/property/list',
    // 众合商品属性
    zhonghe_property_list: '/api/office/school/emall/property/list',
    // 竹马商品列表
    zhuma_app_bar_or_home_list:
        '/api/product/listV3/getPageForAppbarOrHome',
    // 众合商品列表
    zhonghe_app_bar_or_home_list:
        '/api/product/listV3/getPageForAppbarOrHome',
    // 商品列表属性
    product_list_props: '/api/office/school/emall/listByTypeId',
    // 修改收货地址
    update_express_address: '/api/office/app/h5/order/updateExpressAddress',
    update_cart_express_address: '/api/order/v2/updateExpressAddress',
    // 获取当前订单地址
    get_order_address_by_tradeNo:
        '/api/office/app/h5/order/getOrderAddressByTradeNo',

    /**
     * 年货节
     */
    // 商品列表
    nhj_goods_list: '/api/newYear/activity/productList',
    // 签到列表
    list_sign_record: '/api/newYearMerchandiseFestival/listSignRecord',
    // 签到接口
    do_sign: '/api/newYearMerchandiseFestival/doSign',

    // APP调用选择退款服务类型
    // choice_efundType: '/api/app/order/choiceRefundType',
    choice_efundType: '/api/office/app/order/choiceRefundTypeByTradeNo',
    // 获取退款商品信息
    // getApply_refund: '/api/office/app/h5/order/getApplyRefund',
    getApply_refund: '/api/office/app/order/getApplyRefundByTradeNo',
    // 退款接口
    // apply_refund: '/api/office/app/h5/order/applyRefund',
    apply_refund: '/api/office/app/order/applyRefundByTradeNo',
    // 退款列表
    // refund_apply_record: '/api/office/app/h5/order/refundApplyRecord',
    refund_apply_record: '/api/office/app/order/refundApplyRecordByTradeNo',
    // 退款详情
    get_refund_apply_detail: '/api/office/app/h5/order/getRefundApplyDetail',
    // 获取物流信息
    dictItem_by_first_letter: '/api/office/dict/dictItemByFirstLetter',
    // 撤销退款
    refund_revoke: '/api/office/app/h5/order/refundRevoke',
    // 添加退款物流
    add_refund_express: '/api/office/app/h5/order/addRefundExpress',
    // 物流列表
    refund_express_list: '/api/office/app/h5/order/refundExpressList',
    // 物流详情
    refund_express: '/api/office/app/h5/order/refundExpress',
    // 退款申请详情
    get_refund_apply_detail_more:
        '/api/office/app/h5/order/getRefundApplyDetailMore',


    // 物流列表
    // orderExpressList:'/api/office/app/h5/order/orderExpressList',
    orderExpressList:'/api/app/order/orderExpressListByTradeNo',
    //物流详情
    orderDeliverExpress:'/api/office/app/h5/order/orderDeliverExpress',


    /* 社会招聘 */
    // 岗位类别列表
    post_options_list: '/api/internal/recruitmentPostType/list',
    // 岗位信息列表
    post_info_list: '/api/internal/recruitmentPost/list',
    // 岗位详情
    post_detail_list: '/api/internal/recruitmentPost/postInfo',

    /* 我的题库 */
    // 通过用户id获取题库分类
    question_catalog_list: '/api/office/question/list/selectCatalogByUserId',
    // 按日期展示的题型列表
    question_kind_list: '/api/p3/question/list/questionKind',
    // 按日期展示的题库列表
    question_list_by_date:
        'api/office/question/bank/list/selectMyQuestionBankSortByDate',
    // 错题本按全部按日期展示
    question_list_by_date_new:
        'api/office/question/bank/list/selectMyQuestionBankSortByDateNew',
    // 导出题库
    export_questions: '/api/office/question/bank/exportmineQuestionList',
    // 个人中心-查询用户学习计划
    fetch_diagnostics_by_userid: '/api/studyDiagnostics/getDiagnosticsByUserId',

    // node转java第六期
    // 累计、重要卡片-未掌握-已掌握统计
    emphasis_grasp_statistics:
        '/api/office/student/grasp/emphasisGraspStatistics',
    // 专项练习目录查询
    // 根据分类获取上次练习
    get_answer_by_type_id: '/api/office/question/answer/getAnswerByTypeId',
    // 背诵掌握统计（周）
    week_grasp_statistics: '/api/office/student/grasp/weekGraspStatistics',
    // 速记刷题上次练习（包含对应目录下的数据统计）
    practice: '/api/question/answer/practice',
    // (官网)出题接口
    select_by_catalog_id: '/api/office/question/bank/pcSelectByCatalogId',
    // node转java第六期

    // sem重构
    // 获取sem商品列表
    sem_product_list: '/api/sem/getProductList',
    // 获取老师列表
    sem_teacher_list: '/api/sem/getTeacherList',
    // 获取业务类型下的商品类型
    sem_product_type: '/api/sem/product/productType',
    // 用户按钮提交内容
    sem_userform: '/api/sem/button/click',
    // 发送验证码
    send_phoneCode: '/api/sem/sendCode',
    // 校验验证码
    check_code: '/api/sem/checkSmsCode',
    // 用户页面数据收集
    sem_collet_data: '/api/sem/collect/data',
    // 获取semId pageCode
    sem_id: '/api/sem/getPageId',
    // 用户页面点击位置保存
    sem_click_position: '/api/sem/page/click',
    // ABTest
    selectByUrl:'/api/abtest/selectByUrl',
    // sem获取随机数
    sem_get_rate: '/api/sem/getRate',


    // 万人模考
    // 首页活动banner数据
    getBannerData:'/api/mockExam/homePage/getBannerData',
    // 获取活动展示数据
    getActivityData:'/api/mockExam/homePage/getActivityData',
    // 添加反馈
    addFeedBack:'/api/activityUserFeedback/addFeedback',
    // 用户报名接口
    userApply:'/api/mockExam/homePage/signUp',
    // 获取活动状态
    getStatus:'/api/mockExam/homePage/getMockExamStatus',
    getMockExamStatusUser:'/api/mockExam/homePage/getMockExamStatusUser',
    // 考试须知获取
    getNotice:"/api/mockExam/homePage/getNotice",
    // 是否允许进入考试
    allowOrNot:'/api/mockExam/homePage/allowOrNot',
    // 获取答题解析结果
    getPcAnalysis:'/api/simulation/classroom/getPcAnalysis',
    // 获取模考排行榜
    getMockExamRank:'/api/mockExamRank/getMockExamRank',
    // 获取考试结果统计
    getStatics:'/api/mockExamBasicInfo/result/statics',
    // 获取用户收货地址
    getUserAddress:'/api/mockExamRank/getUserAddress',
    // 添加收货地址
    addOrUpdateAddress:'/api/mockExamRank/addOrUpdateAddress',
    // 获取考试信息
    getExamInfo:'/api/mockExamBasicInfo/getExamInfo',
    oldGetClassaParent: '/api/office/analysisRegion/getClassaParent',
    oldGetAnalysisRegionVo: '/api/office/analysisRegion/getAnalysisRegionVo',
    // 检验是否可以进入考场
    checkEnter:'/api/exam/checkEnter',
    // 获取分析报告
    analysisReport:'/api/mockExamBasicInfo/result/analysisReport',
    // 万人模考
    // 积分商城
    // 积分收支明细
    jf_pagePointsRecord:'/api/pointsRecord/pagePointsRecord',
    // 积分任务列表
    jf_pagePointTask:'/api/pointTask/pagePointTask',
    // 积分兑换
    point_exchange_pc:'/api/point/pointExchangePc',

    // 新人活动
    // 新用户券包领取状态
    newuser_coupon_status: '/api/activityNewUser/checkNewUserCouponPackage',
    // 试听课列表
    newuser_audition_list: '/api/newActivity/audition/list',
    // 公开课列表
    newuser_open_list: '/api/newActivity/open/list',
    // 领取券包
    newuser_claim_coupon: '/api/activityNewUser/claimCouponPackage',
    // 登录领好礼
    get_prize: '/api/activityNewUser/claim',
    // 登陆领好礼列表
    get_gift_by_login: '/api/activityNewUser/claimList',
    // 天天登录领好礼状态
    get_claim_status: '/api/activityNewUser/checkTodayClaimStatus',
    // 修改次数 (测试使用)
    changestate: '/api/activityNewUser/updatePosition/{count}',
    // 新人活动

    /* 消息通知 */
    // 分组列表
    message_group_list: '/api/crmMessageGroup/client/groupList',
    // 消息列表
    message_list: '/api/crmUserPushMessage/client/list',
    // 全部已读
    message_all_read: '/api/crmUserPushMessageUnread/updateRead',
    // 查看详情统计
    message_all_read_count: '/api/crmPushMessageStatistics/viewDetails',

    // 错题本接口
    delete_answer_rcord: '/api/question/answer/record/deleteAnswerRcord',
    deleteErrorAnswerRecord: '/api/office/question/answer/record/deleteErrorAnswerRecord',
    questions: '/api/zmweb/v1/exercise/questions',
    insert_notes: '/api/student/note/insertNotes',
    update_notes: '/api/student/note/updateNotes',
    select_question_by_ids: '/api/question/bank/selectQuestionByIds',
    select_catalog_by_user_id_sort_by_date_questions:
        '/api/office/question/bank/list/selectCatalogByUserIdSortByDateQuestions',
    select_catalog_by_user_id_sort_by_date_questions_new:
        '/api/office/question/bank/list/selectCatalogByUserIdSortByDateQuestionsNew',
    mine_question_list: '/api/question/bank/mineQuestionList',
    mine_question_list_new: '/api/question/bank/mineQuestionListNew',
    collect_delete: '/api/student/collect/delete',
    collect_insert: '/api/student/collect/insert',
    query_answer_impersonality:
        '/api/office/question/answer/record/queryAnswerImpersonality',
    office_tencent_sign: '/api/office/tencent/sign',
    // 错题本接口

    // 题库-背诵卡片
    select_by_catalogId: '/api/office/question/bank/pcSelectByCatalogId',
    grasp_save: '/api/student/grasp/save',
    record_answer: '/api/question/answer/record/answerV2',
    error_record_answer: '/api/question/answer/record/answerErrorQuestion',
    record_batch_answer: '/api/question/answer/record/answerBatchV2',
    record_answer_old: '/api/question/answer/record/answer',
    first_answer_recite: '/api/student/grasp/firstAnswerRecite',
    grasp_question_list: '/api/question/bank/graspQuestionList',
    answer_emphasis: '/api/question/answer/emphasis',
    /* 题库-数据报告 */
    // 用户信息
    tiku_report_user_info: '/api/office/question/answer/record/graspingOrder',
    // 用户做题数据
    tiku_report_user_answer_data:
        '/api/office/question/answer/indexImpAnswerStatistics',
    // 用户做题数据(今日，本周，本月)
    tiku_report_user_dwm_data:
        '/api/office/question/selectCatalogStatisticsByParentId',
    // 用户掌握情况排名
    tiku_report_ranking: '/api/office/question/answer/record/graspingState',
    // 用户做题分布Top3
    tiku_report_top_three: '/api/question/selectTopThreeCatalogByParentId',
    // 章节练习tab数据
    tiku_report_chapter_tabs: '/api/office/question/list/questionType',
    // 章节练习数据
    tiku_report_chapter_list: '/api/question/selectStatisticsCatalogByParentId',
    /* 题库-数据报告详情 */
    // 用户做题情况
    tiku_report_details_catalog:
        '/api/office/question/answer/catalogImpAnswerStatistics',
    // 荣誉称号说明列表
    tiku_report_title_honour: '/api/office/titleHonour/list',
    /* 题库-速记题 */
    // 速记题-用户数据
    tiku_suji_question_type: '/api/question/answer/mineQuestionBank',
    // 速记题-用户做题数据
    tiku_suji_question_data:
        '/api/question/answer/indexShorthandDataStatistics',
    /* 题库-历年真题 */

    suji_again:'/api/question/v2/preSelectVerify',

    // 历年真题列表类型
    suji_again_do: '/api/question/v2/lastAnswerPop',
    suji_again_list: '/api/question/v2/lastAnswerPopClear',
    tiku_years_list: '/api/p3/question/list/appCatalog',

    //解析页埋点
    get_bury_data: '/api/question/bank/getQuestionInfoForSensor',
    getUniqueAnswerTerminal:'/api/question/v2/getUniqueAnswerTerminal',
    // 随堂练习获取uuid
    getClassroomAnswerTerminal:'/api/office/classroom/getClassroomAnswerTerminal',
    // 题库-我的卡片
    grasp_catalog_list: '/api/question/list/graspCatalogList',
    question_type: '/api/office/question/list/questionType',

    /* 题库-智能组卷 */
    tiku_zujuan_data: '/api/office/question/list/queryAiCatalogList',

    // 精选案例列表
    query_question_list: '/api/question/bank/queryQuestionList',
    answer_practice: '/api/office/question/answer/practice',

    //是否出题
    canSelect: 'api/office/question/v2/canSelect',

    // 背诵数据报告
    select_three_index_grasp_statistics:
        '/api/student/grasp/selectThreeIndexGraspStatistics',
    select_index_grasp_statistics:
        '/api/student/grasp/selectIndexGraspStatistics',
    select_catalog_statistics_by_parentId:
        '/api/question/selectCatalogStatisticsByParentId',
    recite_statistics: '/api/question/answer/record/reciteStatistics',

    // 搜索结果页面
    select_question_by_like: '/api/question/bank/selectQuestionByLike',

    // 速记卡片页面
    select_catalog_by_user_id: '/api/question/list/selectCatalogByUserId',
    catalog_imp_answer_statistics:
        '/api/question/answer/catalogImpAnswerStatistics',
    shorthand_question_list: '/api/question/bank/shorthandQuestionList',
    // 智能组卷出题接口
    get_zhinengzujuan_question: '/api/intelligentTestPaper/getAiQuestionList',
    // 新出题接口
    get_new_question: '/api/question/v2/selectByCatalogId',
    // 获取题集
    get_questionList: 'api/question/v2/getQuestionList',
    get_zhinengzujuan_question: '/api/question/bank/pastAiQuestionList',
    // 新智能组卷出题接口
    new_get_zhinengzujuan_question: '/api/intelligentTestPaper/getAiQuestionList',


    // 答题解析页面（做完题的解析页面）
    // 采分点报错提交接口
    reporterror_save: '/api/reporterror/save',

    // 刷题答案解析接口
    get_pc_analysis: '/api/office/simulation/classroom/getPcAnalysis',
    // 模考答案解析接口
    mokao_pc_analysis: '/api/office/exam/getPcAnalysis',
    delete_answer_rcord: '/api/question/answer/record/deleteAnswerRcord',
    save_or_update_notes: '/api/student/classroom/notes/saveOrUpdateNotes',
    // 学习效果测试
    get_effect: '/api/simulation/classroom/getTestPaper',
    // 学习效果测试提交
    effect_answer: '/api/simulation/classroom/answer',
    // 一题一练
    one_get_question: '/api/question/bank/createQuestionList',

    //交卷判断
    lnzt_canSubmit:'/api/office/question/v2/canSubmit',
    //判断多端
    getUniqueAnswerTerminal: '/api/question/v2/getUniqueAnswerTerminal',

    // 订单合同信息
    hetong_info: '/api/eqianbao/listByTradeNo/',

    // 偶尔发题给用户作答时的判断能否作答的接口
    lt_exercise: '/api/temporaryMockExamUser/getUserWhiteList',
    get_answer_result: '/api/question/answer/answerResule',
    // 判断能不能进入考试
    allowOrNot:'/api/mockExam/homePage/allowOrNot',
    // 模考活动
    getQuestion:'/api/office/exam/getQuestion',
    // 万人模考答题接口
    mokao_answer:'/api/office/exam/answer',
    // 案例代写
    anlidaixie: '/api/office/answer/questions/queryQuestions',

    // 新品推荐类型列表
    new_product_types: '/api/newProductRecommend/productTypes',
    // 新品推荐列表
    new_product_goods: '/api/newProductRecommend/page',
    // 督学随堂练习列表
    getExamCountDown:'/api/simulation/classroom/getExamCountDown',

    // 众合商品详情相关推荐
    get_product_and_recommend: '/api/pointProduct/getProductAndRecommend',
    // 前台积分任务
    get_point_task_info: '/api/pointTask/getPointTaskInfo',
    // 获取现有积分信息
    get_existing_point_by_user_id:"/api/pointsRecord/getExistingPointByUserId",
    /**
     * 积分商城接口
     */

    // 717 体验营加群H5
    get_eul_QrCodeUrl: '/api/qrCode/getQrCodeUrl',
    // 四月民刑摸底模考 查看是否可以查看答案
    get_seeAnswer: '/api/mockExamBasicInfo/seeAnswer',
    // 四月民刑摸底模考 查看答案
    get_seeQuestionInfo: '/api/mockExamBasicInfo/seeQuestionInfo',
    // 智能组卷 试卷分类/卷别分类 写死
    getBothType: '/api/intelligentTestPaper/getFilterCondition',

    // 我的提问/回答列表，获取查询条件
    get_business_and_subject: '/api/emall/product/selectBusinessAndSubjectInfo',
    // 提问/追问/回答buttonStatu
    get_button_status: '/api/office/professionalQa/getQaButtonStatus',
    /** 解析页面接口优化 */
    // 单个试题解析
    getQuestionAnalysisById: '/api/office/question/v2/getQuestionAnalysisById',
    // 错题试题解析
    getErrorQuestionAnalysisById: '/api/office/question/v2/getErrorQuestionAnalysisById',
    // 试题解析列表1
    listQuestionAnalysis: '/api/office/question/v2/listQuestionAnalysis',
    listQuestionAnalysisError: '/api/office/question/v2/listQuestionAnalysisError',
    //错题解析
    errorAnswerResult: '/api/office/question/answer/errorAnswerResult',
    // 试题解析列表2
    listQuestionAnalysisForOverallReport: '/api/office/question/v2/listQuestionAnalysisForOverallReport',
    /** 解析页面接口优化 */

    // 学习效果测试
    // tab
    getType:'/api/simulation/classroom/getType',
    // 根据tab获取二级tab
    getSubject:'/api/simulation/classroom/getSubject',
    // 获取列表
    classroomList:'/api/simulation/classroom/pcClassroomList',
    // 随堂测试获取榜单列表
    getRankList:'/api/simulation/classroom/getRankList',

    // 获取模考考试倒计时
    get_mokao_countdown: '/api/mockExam/homePage/getCountdown',

    // 获取水印类型 waterThirdMark：三方水印 0 关闭 1开启  waterSelfMark：自身水印 0 关闭 1开启
    getWaterMark: '/api/office/app/emall/getWaterMark',
    //  通过模考id获取模拟信息
    getQuickEnter:'/api/office/mockExamBasicInfo/getQuickEnter',

    /** 854 模考优化接口 */
    // 说明页-弹窗
    getUserExamTime: '/api/exam/v2/getUserExamTime',
    //学习效果测试 说明页弹窗
    getClassroomPracticeTime:'/api/classroom/getClassroomPracticeTime',
    // 多端校验
    checkPage: '/api/office/exam/v2/checkPage',
    // 模考新出题接口
    getMockExam: '/api/office/exam/v2/getQuestion',
    // 模考获取题集
    getQuestionById: '/api/office/exam/v2/getQuestionById',
    // 解析接口 获取题号信息
    mockGetAnalysis: '/api/office/exam/v2/getAnalysis',
    fetchAnalysisAll: '/api/exam/v2/getAnalysisAll',
    fetchUserAnalysis: '/api/exam/v2/getUserAnalysis',
    // 解析接口 获取题详情接口
    mockGetAnalysisByIds: '/api/office/exam/v2/getAnalysisByIds',
    // 模考答题提交
    mockExamAnswer: '/api/exam/v2/answer',
    // 万人模考-获取考场名称
    getMockRoom: '/api/office/exam/v2/getMockRoom',
    /** 854 模考优化接口 */

    // 获取取消订单原因
    get_cancel_order_reason: '/api/dict/getCancelPaymentReason',
    // 取消订单
    submit_cancel_order: '/api/app/h5/order/myOrderCancelPaymentByTradeNo',

    // 用户最近学习记录，返回空=不存在最近学习记录 (课程点击之前掉用，在调用判断是否有课程的接口)
    lastStudyRecord: '/api/office/course/lastStudyRecord',
    // PC-获取用户上次播放速率及清晰度
    getPlayAndClarity: '/api/office/emall/getPlayAndClarity',
    // PC-缓存用户上次播放速率及清晰度
    setPlayAndClarity: '/api/office/emall/setPlayAndClarity',
    // 学习效果测试页面 最近学习
    getLastClassroomAnswer:'/api/classRoomPracticeExtend/getLastClassroomAnswer',
    // 学习效果测试拓展业务(错题本、笔记、收藏、记录) 852
    // 错题本,笔记,收藏 按日期展示
    pageRecordByDate:'api/classRoomPracticeExtend/pageRecordByDate',
    // 错题本,笔记,收藏 按试卷展示
    pageRecordByTestPaper:'api/classRoomPracticeExtend/pageRecordByTestPaper',
    // 错题本,笔记,收藏 导出
    exportQuestionList:'api/classRoomPracticeExtend/exportQuestionList',
    // 做题记录 列表
    pageClassroomAnswerHistory:'api/classRoomPracticeExtend/pageClassroomAnswerHistory',
    // 出题 新接口 856技术需求,可参照856接口文档
    getQuestionSet:'api/office/classroom/getQuestionSet',
    // 学习效果测试提交
    new_effect_answer:'api/classroom/answerV2',
    // 获取学习效果测试解析
    get_effect_question:'api/classroom/getClassroomAnalysisListForClient',
    // 学习效果测试获取题目解析(单个)
    get_effect_analysis:'api/classroom/getQuestionAnalysisSingle',
    // 学习效果测试收藏题目
    question_collect_edit:'api/classroomPractice/collect/editCollect',
    // 获取学习效果测试解析列表
    getClassroomAnalysisListForClient:'api/classroom/getClassroomAnalysisListForClient',
    // 获取答题结果页面
    getAnswerResult:'api/classroom/answerResult',
    // 学习效果测试 获取新的批量试题
    effect_getQuestionList:'api/classroom/getQuestionList',
    // 新增或修改笔记
    add_or_edit_note:'api/office/student/classroom/notes/saveOrUpdateNotes',
    // 随堂练习获取倒计时/答题耗时'
    getCountDown:'api/classroom/getCountDown',
    // 是否可以出题
    can_select_api: '/api/office/question/v2/canSelect',

    // 当天第一次进入首页事件(仅适用于PC端)
    user_first_enter_home: 'api/burialPoint/addFirstEnterHomeEventForPc',

    modMockExamCheckedQuestion :'/api/exam/v2/modMockExamCheckedQuestion',
    // 获取当前用户下的课程商品分类->(app+pc+h5)
    my_course_product_type_list: '/api/course/page/myCourseProductTypeList'
}
